window.changeExpensesNoticeButtonDisabledState = function(){
  $('#read_expenses_notice').prop('disabled', !$('#i_understand').is(':checked'));
}
